export const ERROR_STATE_MAP = {
  // CONTACT SUPPORT
  A001: 'CONTACT_SUPPORT',
  A003: 'CONTACT_SUPPORT',
  A004: 'CONTACT_SUPPORT',
  A010: 'CONTACT_SUPPORT',
  A011: 'CONTACT_SUPPORT',
  A012: 'CONTACT_SUPPORT',

  602: 'CONTACT_SUPPORT',
  730: 'CONTACT_SUPPORT',
  801: 'CONTACT_SUPPORT',
  802: 'CONTACT_SUPPORT',
  809: 'CONTACT_SUPPORT',
  9000: 'CONTACT_SUPPORT',

  I001: 'CONTACT_SUPPORT',
  I002: 'CONTACT_SUPPORT',
  I003: 'CONTACT_SUPPORT',
  I005: 'CONTACT_SUPPORT',
  I100: 'CONTACT_SUPPORT',
  I101: 'CONTACT_SUPPORT',
  I102: 'CONTACT_SUPPORT',
  I104: 'CONTACT_SUPPORT',
  I105: 'CONTACT_SUPPORT',
  I106: 'CONTACT_SUPPORT',
  I109: 'CONTACT_SUPPORT',
  I110: 'CONTACT_SUPPORT',
  I111: 'CONTACT_SUPPORT',
  I113: 'CONTACT_SUPPORT',
  I141: 'CONTACT_SUPPORT',
  I142: 'CONTACT_SUPPORT',
  I143: 'CONTACT_SUPPORT',
  I144: 'CONTACT_SUPPORT',
  I201: 'CONTACT_SUPPORT',
  I202: 'CONTACT_SUPPORT',
  I203: 'CONTACT_SUPPORT',
  I204: 'CONTACT_SUPPORT',
  I999: 'CONTACT_SUPPORT',

  OC01: 'CONTACT_SUPPORT',
  OC04: 'CONTACT_SUPPORT',

  OD06: 'CONTACT_SUPPORT',

  S004: 'CONTACT_SUPPORT',
  S007: 'CONTACT_SUPPORT',
  S801: 'CONTACT_SUPPORT',

  9905: 'CONTACT_SUPPORT',
  9908: 'CONTACT_SUPPORT',
  9950: 'CONTACT_SUPPORT',
  9951: 'CONTACT_SUPPORT',
  9964: 'CONTACT_SUPPORT',
  9965: 'CONTACT_SUPPORT',

  1200: 'CONTACT_SUPPORT',
  1201: 'CONTACT_SUPPORT',
  1051: 'CONTACT_SUPPORT',
  1070: 'CONTACT_SUPPORT',
  1100: 'CONTACT_SUPPORT',
  1101: 'CONTACT_SUPPORT',
  1102: 'CONTACT_SUPPORT',
  1106: 'CONTACT_SUPPORT',
  1107: 'CONTACT_SUPPORT',
  1114: 'CONTACT_SUPPORT',

  1160: 'CONTACT_SUPPORT',
  1161: 'CONTACT_SUPPORT',
  1162: 'CONTACT_SUPPORT',
  1163: 'CONTACT_SUPPORT',
  1164: 'CONTACT_SUPPORT',
  1165: 'CONTACT_SUPPORT',

  9903: 'CONTACT_SUPPORT',
  S254: 'CONTACT_SUPPORT',
  1208: 'CONTACT_SUPPORT',

  1209: 'CONTACT_SUPPORT',
  1166: 'CONTACT_SUPPORT',
  1168: 'CONTACT_SUPPORT',
  1169: 'CONTACT_SUPPORT',
  1170: 'CONTACT_SUPPORT',
  1171: 'CONTACT_SUPPORT',
  1172: 'CONTACT_SUPPORT',
  1202: 'CONTACT_SUPPORT',

  1206: 'CONTACT_SUPPORT',
  1211: 'CONTACT_SUPPORT',
  1212: 'CONTACT_SUPPORT',
  1213: 'CONTACT_SUPPORT',
  1219: 'CONTACT_SUPPORT',

  1238: 'CONTACT_SUPPORT',
  1239: 'CONTACT_SUPPORT',
  1242: 'CONTACT_SUPPORT',
  1245: 'CONTACT_SUPPORT',
  1248: 'CONTACT_SUPPORT',
  1251: 'CONTACT_SUPPORT',
  1253: 'CONTACT_SUPPORT',
  1255: 'CONTACT_SUPPORT',
  1257: 'CONTACT_SUPPORT',
  1258: 'CONTACT_SUPPORT',
  1259: 'CONTACT_SUPPORT',
  1260: 'CONTACT_SUPPORT',
  1261: 'CONTACT_SUPPORT',
  1262: 'CONTACT_SUPPORT',
  1267: 'CONTACT_SUPPORT',

  S427: 'CONTACT_SUPPORT',
  9906: 'CONTACT_SUPPORT',

  I145: 'CONTACT_SUPPORT',

  // N/A error code (for < 40 cents validation)
  'N/A': 'CONTACT_SUPPORT',

  // TRY AGAIN
  4021: 'TRY_AGAIN',

  // TRY AGAIN LATER
  A002: 'TRY_AGAIN_LATER',
  A005: 'TRY_AGAIN_LATER',
  A006: 'TRY_AGAIN_LATER',
  A009: 'TRY_AGAIN_LATER',

  530: 'TRY_AGAIN_LATER',
  999: 'TRY_AGAIN_LATER',
  2002: 'TRY_AGAIN_LATER',
  2003: 'TRY_AGAIN_LATER',
  2004: 'TRY_AGAIN_LATER',
  2005: 'TRY_AGAIN_LATER',
  2006: 'TRY_AGAIN_LATER',
  2007: 'TRY_AGAIN_LATER',
  2008: 'TRY_AGAIN_LATER',
  2009: 'TRY_AGAIN_LATER',
  2010: 'TRY_AGAIN_LATER',
  2012: 'TRY_AGAIN_LATER',
  2033: 'TRY_AGAIN_LATER',
  2038: 'TRY_AGAIN_LATER',
  2062: 'TRY_AGAIN_LATER',

  S012: 'TRY_AGAIN_LATER',
  9910: 'TRY_AGAIN_LATER',
  9912: 'TRY_AGAIN_LATER',

  1203: 'TRY_AGAIN_LATER',
  1205: 'TRY_AGAIN_LATER',
  1214: 'TRY_AGAIN_LATER',
  1215: 'TRY_AGAIN_LATER',
  1216: 'TRY_AGAIN_LATER',
  1217: 'TRY_AGAIN_LATER',
  1218: 'TRY_AGAIN_LATER',

  // TRY AGAIN TOMORROW
  S157: 'TRY_AGAIN_TOMORROW',

  // UNLINK AND LINK ACCOUNT
  S700: 'UNLINK_AND_LINK_ACCOUNT',
  S701: 'UNLINK_AND_LINK_ACCOUNT',
  S702: 'UNLINK_AND_LINK_ACCOUNT',
  S703: 'UNLINK_AND_LINK_ACCOUNT',

  OC03: 'UNLINK_AND_LINK_ACCOUNT',
  OD03: 'UNLINK_AND_LINK_ACCOUNT',

  S008: 'UNLINK_AND_LINK_ACCOUNT',
  1010: 'UNLINK_AND_LINK_ACCOUNT',
  1041: 'UNLINK_AND_LINK_ACCOUNT',
  1042: 'UNLINK_AND_LINK_ACCOUNT',
  1237: 'UNLINK_AND_LINK_ACCOUNT',
  1243: 'UNLINK_AND_LINK_ACCOUNT',
  1252: 'UNLINK_AND_LINK_ACCOUNT',
  1207: 'UNLINK_AND_LINK_ACCOUNT',

  // giving-api's own codes (not DBS's)
  // Expired without a bank response: never sent, safe to retry.
  TIMEOUT_EXPIRED: 'TRY_AGAIN',
  // Sent, but the bank never confirmed it: it may have gone through.
  UNCONFIRMED_EXPIRED: 'CHECK_BANK',
  SYSTEM_ERROR: 'TRY_AGAIN_LATER',
};
